import * as React from 'react';
import Menu from '@mui/material/Menu';
import { Button } from 'react-bootstrap';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { appMenuGroups, icons, routers } from 'router/router';
import { useHistory, useLocation } from 'react-router';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import EducationProgramsIcon from 'components/icons/EducationProgramsIcon';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import ToolsAnalyticsIcon from 'components/icons/ToolsAnalyticsIcon';
import { getUserId } from 'utils/sessionStorage';

export default function MobileMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const [title, setTitle] = React.useState('Menu');
  let location = useLocation();
  const handleClickButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const redirectPage = async (child: any) => {
    setAnchorEl(null);

    // Get user ID from cookies
    const userId = getUserId();
    
    // Replace :id parameter with actual user ID for summary routes
    let path = child?.path;
    if (path && path.includes(':id') && userId) {
      path = path.replace(':id', userId);
    }

    history.push(path);
  };
  const [open, setOpen] = React.useState<string | null>(null);
  let history = useHistory();
  const handleClick = (route: any) => {
    // If it's not a group, redirect directly
    if (!route.isGroup && route.route) {
      redirectPage(route.route);
      return;
    }
    
    // If it's a group, toggle open/close
    if (open === route.name) return setOpen(null);
    setOpen(route.name);
  };
  React.useEffect(() => {
    appMenuGroups.forEach((route: any) => {
      // Check if current path matches a non-group route
      if (!route.isGroup && route.route) {
        // Handle routes with :id parameter
        if (route.route.path.includes(':id')) {
          const userId = getUserId();
          if (userId) {
            const dynamicPath = route.route.path.replace(':id', userId);
            if (dynamicPath === location.pathname) {
              setTitle(route.name);
              return;
            }
          }
        } else if (route.route.path === location.pathname) {
          setTitle(route.name);
          return;
        }
      }
      
      // Check if current path matches a child route in a group
      const currentRoute = route.children.find((e: any) => {
        if (e?.path && e.path.includes(':id')) {
          const userId = getUserId();
          if (userId) {
            const dynamicPath = e.path.replace(':id', userId);
            return dynamicPath === location.pathname;
          }
        }
        return e?.path === location.pathname;
      });
      if (currentRoute) {
        setOpen(route.name);
        setTitle(currentRoute.name);
      }
    });
  }, [location]);
  return (
    <div className="modern-mobile-menu">
      <Button 
        variant="outline-primary" 
        onClick={handleClickButton}
        className="modern-menu-button"
        style={{
          borderRadius: '12px',
          border: '2px solid #4d88f0',
          background: 'white',
          color: '#4d88f0',
          fontWeight: '600',
          fontSize: '0.95rem',
          padding: '12px 20px',
          boxShadow: '0 2px 8px rgba(77, 136, 240, 0.15)',
          transition: 'all 0.3s ease',
          minWidth: '120px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#4d88f0';
          e.currentTarget.style.color = 'white';
          e.currentTarget.style.transform = 'translateY(-1px)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(77, 136, 240, 0.25)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'white';
          e.currentTarget.style.color = '#4d88f0';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(77, 136, 240, 0.15)';
        }}
      >
        <span>{title}</span>
        <ExpandMore 
          fontSize="small" 
          style={{ 
            transform: openMenu ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease'
          }} 
        />
      </Button>
      <Menu
        anchorEl={anchorEl}
        onClose={handleClose}
        open={openMenu}
        PaperProps={{
          style: {
            width: '100%',
            maxWidth: '320px',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(78, 90, 111, 0.12), 0 2px 8px rgba(78, 90, 111, 0.08)',
            border: '1px solid rgba(77, 136, 240, 0.1)',
            marginTop: '8px',
            padding: '8px',
            background: 'white'
          },
        }}
        transformOrigin={{ horizontal: 'center', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      >
        <List sx={{ 
          width: '100%', 
          bgcolor: 'transparent',
          padding: '4px 0'
        }}>
          <ListItemButton
            onClick={async () => {
              await redirectPage(routers.dashBoard);
            }}
            sx={{
              borderRadius: '12px',
              margin: '2px 0',
              padding: '12px 16px',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(77, 136, 240, 0.08)',
                transform: 'translateX(4px)'
              }
            }}
          >
            <DashboardOutlinedIcon
              sx={{ 
                color: '#4d88f0',
                marginRight: '12px',
                fontSize: '20px'
              }}
            />
            <span style={{ 
              fontWeight: '500',
              color: '#0c2551',
              fontSize: '0.95rem'
            }}>
              Dashboard
            </span>
          </ListItemButton>
          {/* <ListItemButton
            onClick={async () => {
              await redirectPage(routers.support);
            }}
          >
            <SmsOutlinedIcon
              className="text-field-light"
              style={{ marginLeft: '-12px', marginRight: '4px' }}
            />
            <span className="mr-1 pr-1">Support</span>
          </ListItemButton> */}
          {appMenuGroups.map((route: any, index: any) => {
            const IconBefore = icons[route.icon] || 'Component';
            return (
              <div key={index}>
                <ListItemButton
                  onClick={() => handleClick(route)}
                  sx={{
                    borderRadius: '12px',
                    margin: '2px 0',
                    padding: '12px 16px',
                    transition: 'all 0.2s ease',
                    backgroundColor: open === route.name ? 'rgba(77, 136, 240, 0.1)' : 'transparent',
                    '&:hover': {
                      backgroundColor: open === route.name ? 'rgba(77, 136, 240, 0.15)' : 'rgba(77, 136, 240, 0.08)',
                      transform: 'translateX(4px)'
                    }
                  }}
                >
                  <IconBefore 
                    sx={{ 
                      color: '#4d88f0',
                      marginRight: '12px',
                      fontSize: '20px'
                    }} 
                  />
                  <span style={{ 
                    fontWeight: open === route.name ? '600' : '500',
                    color: '#0c2551',
                    fontSize: '0.95rem',
                    flex: 1
                  }}>
                    {route.name}
                  </span>
                  {route.isGroup &&
                    (open === route.name ? (
                      <ExpandLess 
                        sx={{ 
                          color: '#4d88f0',
                          fontSize: '18px',
                          transition: 'transform 0.3s ease'
                        }} 
                      />
                    ) : (
                      <ExpandMore 
                        sx={{ 
                          color: '#4d88f0',
                          fontSize: '18px',
                          transition: 'transform 0.3s ease'
                        }} 
                      />
                    ))}
                </ListItemButton>
                {route.isGroup && (
                  <Collapse in={open === route.name} timeout="auto" unmountOnExit>
                    <List 
                      component="div" 
                      disablePadding
                      sx={{
                        paddingLeft: '8px',
                        marginTop: '4px'
                      }}
                    >
                      {route.children.map((child: any, i: number) => {
                        const isActive = (() => {
                          if (child?.path && child.path.includes(':id')) {
                            const userId = getUserId();
                            if (userId) {
                              const dynamicPath = child.path.replace(':id', userId);
                              return dynamicPath === location.pathname;
                            }
                          }
                          return location.pathname === child?.path;
                        })();

                        return (
                          <ListItemButton
                            key={i}
                            onClick={async () => {
                              await redirectPage(child);
                            }}
                            sx={{
                              borderRadius: '10px',
                              margin: '1px 0',
                              padding: '10px 16px',
                              marginLeft: '16px',
                              transition: 'all 0.2s ease',
                              backgroundColor: isActive ? 'rgba(77, 136, 240, 0.12)' : 'transparent',
                              borderLeft: isActive ? '3px solid #4d88f0' : '3px solid transparent',
                              '&:hover': {
                                backgroundColor: isActive ? 'rgba(77, 136, 240, 0.18)' : 'rgba(77, 136, 240, 0.06)',
                                transform: 'translateX(2px)',
                                borderLeft: '3px solid #4d88f0'
                              }
                            }}
                          >
                            <span style={{ 
                              marginRight: '12px',
                              fontSize: '16px',
                              color: isActive ? '#4d88f0' : '#8894aa'
                            }}>
                              {child?.icon}
                            </span>
                            <span style={{
                              fontWeight: isActive ? '600' : '400',
                              color: isActive ? '#4d88f0' : '#0c2551',
                              fontSize: '0.9rem'
                            }}>
                              {child?.name}
                            </span>
                          </ListItemButton>
                        );
                      })}
                    </List>
                  </Collapse>
                )}
              </div>
            );
          })}

          <ListItemButton
            onClick={async () => {
              // await redirectPage(routers.dashBoard);
            }}
            sx={{
              borderRadius: '12px',
              margin: '2px 0',
              padding: '12px 16px',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(77, 136, 240, 0.08)',
                transform: 'translateX(4px)'
              }
            }}
          >
            <ToolsAnalyticsIcon
              sx={{ 
                color: '#4d88f0',
                marginRight: '12px',
                fontSize: '20px'
              }}
            />
            <span style={{ 
              fontWeight: '500',
              color: '#0c2551',
              fontSize: '0.95rem'
            }}>
              Tools & Analytics
            </span>
          </ListItemButton>


          <ListItemButton
            onClick={async () => {
              await redirectPage(routers.summerPrograms);
            }}
            sx={{
              borderRadius: '12px',
              margin: '2px 0',
              padding: '12px 16px',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(77, 136, 240, 0.08)',
                transform: 'translateX(4px)'
              }
            }}
          >
            <EducationProgramsIcon
              sx={{ 
                color: '#4d88f0',
                marginRight: '12px',
                fontSize: '20px'
              }}
            />
            <span style={{ 
              fontWeight: '500',
              color: '#0c2551',
              fontSize: '0.95rem'
            }}>
              Summer Programs
            </span>
          </ListItemButton>

        </List>
      </Menu>
    </div>
  );
}
